import type { EditHistoryEntry } from './types';

const MAX_HISTORY = 20;

/**
 * Push a new edit history entry onto an existing history array.
 * - Dedupes: if the most recent entry is the same user within 5 minutes, updates timestamp instead of adding new.
 * - Keeps at most MAX_HISTORY entries (newest first).
 */
export function pushEditHistory(
  existing: EditHistoryEntry[] | undefined,
  userName: string,
  userId?: string,
  action: EditHistoryEntry['action'] = 'edited',
): EditHistoryEntry[] {
  const history = existing ? [...existing] : [];
  const now = new Date().toISOString();

  // Dedupe: if same user edited within last 5 minutes, just update timestamp
  if (history.length > 0) {
    const last = history[0];
    if (last.userName === userName && last.action === action) {
      const elapsed = Date.now() - new Date(last.timestamp).getTime();
      if (elapsed < 5 * 60 * 1000) {
        history[0] = { ...last, timestamp: now };
        return history;
      }
    }
  }

  history.unshift({ userName, userId, timestamp: now, action });

  if (history.length > MAX_HISTORY) history.length = MAX_HISTORY;

  return history;
}
